export enum ClientSideStorageType {
  Unknown = 0,
  Necessary = 1 << 0, // 0001
  Functional = 1 << 1, // 0010
  Analytics = 1 << 2, // 0100
}
